import * as React from 'react';
import { Route } from 'react-router-dom';
import { paths } from '@/config';
import { SignUp } from '@/components/Pages';
import enhance from './enhancer';

function SignUpRoutes() {
  return <Route strict path={paths.before.signup} component={SignUp} />;
}

export default enhance((props) => <SignUpRoutes {...props} />);
